var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LeagueInfoData } from "../LeagueInfoData";
var LeagueInfo = /** @class */ (function (_super) {
    __extends(LeagueInfo, _super);
    function LeagueInfo(leagueInfoData) {
        return _super.call(this, leagueInfoData) || this;
    }
    LeagueInfo.prototype.checkCountryProps = function (league) {
        return this.CountryCode === league.CountryCode &&
            this.CountryTranslatedName === league.CountryTranslatedName &&
            this.isUserCountry === league.isUserCountry &&
            this.UrlCode === league.UrlCode;
    };
    LeagueInfo.prototype.compareByRankAndName = function (l1, l2) {
        if (l1.RankID > l2.RankID) {
            return 1;
        }
        if (l1.RankID < l2.RankID) {
            return -1;
        }
        if (l1.Name > l2.Name) {
            return 1;
        }
        if (l1.Name < l2.Name) {
            return -1;
        }
        return 0;
    };
    LeagueInfo.prototype.equals = function (league) {
        return this.ID === league.ID &&
            this.Name === league.Name &&
            this.RankID === league.RankID &&
            this.hasLiveStream === league.hasLiveStream &&
            this.MasterLeagueID === league.MasterLeagueID &&
            this.checkCountryProps(league);
    };
    LeagueInfo.prototype.compareTo = function (league) {
        return this.compareByRankAndName(this, league);
    };
    LeagueInfo.prototype.getFullName = function () {
        return this.Name + " (" + this.CountryTranslatedName + ")";
    };
    return LeagueInfo;
}(LeagueInfoData));
export { LeagueInfo };
//# sourceMappingURL=LeagueInfo.js.map